import { BottomSheet } from 'react-spring-bottom-sheet';
import 'react-spring-bottom-sheet/dist/style.css';
import RegularMonthDueV1 from '../../components/wallets/RegularMonthDuev1';
import MainOddsPopup from '../../components/common/oddsPopup/MainOddsPopup';


export default function AmountPayDueWeb({children}) {
  return (
    <MainOddsPopup>
      {children}
    </MainOddsPopup>
  );
}
